import React, { useMemo } from 'react';
import _get from 'lodash/get';
import _isArray from 'lodash/isArray';

import { UiKit } from 'components';

export function ProductCategories({
  list = [],
  value = null,
  onChange = () => {}
}) {
  const { options, optionsMap } = useMemo(() => createOptions(list), [list]);

  const selected = _get(optionsMap, value, null);

  return (
    <UiKit.Select
      isNested
      label="Product Category"
      value={selected}
      options={options}
      onChange={option => onChange(option.id)}
    />
  );
}

function createOptions(list = [], depth = 0) {
  const value = { options: [], optionsMap: {} };

  if (!_isArray(list)) return value;

  return list.reduce((acc, item) => {
    const data = { value: item.id, label: item.label, depth };
    const { options, optionsMap } = createOptions(item.options, depth + 1);
    acc.options.push({ ...item, ...data, options });
    acc.optionsMap[item.id] = data;
    acc.optionsMap = { ...acc.optionsMap, ...optionsMap };
    return acc;
  }, value);
}
